const checkIfLot = (area, property) => {
  if (property.TotalArea > 0 && property.Area > 0) {
    return `<li class="area">${area}:<span>${property.TotalArea} / ${property.Area} m<sup>2</sup></span></li>`;
  }
  return ``;
};

const getPropertyHtml = (labels, property) => {
  const template = `
      <article class="card prospect-card">
        <a href="/prospekt?&id=${property.Id}">
          <div class="card-content">
            <div id="ID_${property.Id}" class="card-image as-background"></div>
            <div class="card-body">
              <ul>
                <li>${property.Description}</li>
                <li class="price">${labels.price}:<span>${property.Price}</span></li>`
                + checkIfLot(labels.area, property) +
                `<li>${property.PropertyTypeAndOwnershipForm}</li>
                <li>
                  <address>
                    ${property.Address}
                  </address>
                </li>
            </ul>
          </div>
        </div>
        <div class="sold-sticker">${labels.sold}</div>
      </a>
    </article>

    <style>
        @media (min-width: 1010px) {
            #ID_${property.Id} {
                background-image: url('${property.PhotoSmall}');
            }

            @media only screen and (-webkit-min-device-pixel-ratio: 2),
                    only screen and ( min--moz-device-pixel-ratio: 2),
                    only screen and ( -o-min-device-pixel-ratio: 2/1),
                    only screen and ( min-device-pixel-ratio: 2),
                    only screen and ( min-resolution: 192dpi),
                    only screen and ( min-resolution: 2dppx) {
                    #ID_${property.Id} {
                        background-image: url('${property.PhotoSmall2x}');
                    }
            }
        }

        @media (min-width: 680px) and (max-width: 1009px) {
            #ID_${property.Id} {
                background-image: url('${property.PhotoMedium}');
            }

            @media only screen and (-webkit-min-device-pixel-ratio: 2),
                    only screen and ( min--moz-device-pixel-ratio: 2),
                    only screen and ( -o-min-device-pixel-ratio: 2/1),
                    only screen and ( min-device-pixel-ratio: 2),
                    only screen and ( min-resolution: 192dpi),
                    only screen and ( min-resolution: 2dppx) {
                    #ID_${property.Id} {
                        background-image: url('${property.PhotoMedium2x}');
                    }
            }
        }

        @media (max-width: 679px) {
            #ID_${property.Id} {
                background-image: url('${property.PhotoLarge}');
          }

            @media only screen and (-webkit-min-device-pixel-ratio: 2),
                    only screen and ( min--moz-device-pixel-ratio: 2),
                    only screen and ( -o-min-device-pixel-ratio: 2/1),
                    only screen and ( min-device-pixel-ratio: 2),
                    only screen and ( min-resolution: 192dpi),
                    only screen and ( min-resolution: 2dppx) {
                    #ID_${property.Id} {
                        background-image: url('${property.PhotoLarge2x}');
                  }
            }
        }
    </style>`;

  return template;
};

export { getPropertyHtml };
